import React from 'react';
import { Link } from 'react-router-dom';
import { getBodyRegionDefinition } from '../../data/bodyMapRegions';
import type { BodyIssueRecord, BodyRegionKey } from '../../types/bodyMapIssue';

interface Props {
  issues: BodyIssueRecord[];
  selectedRegionKey: BodyRegionKey | null;
}

export default function BodyIssueList({ issues, selectedRegionKey }: Props) {
  const filteredIssues = selectedRegionKey
    ? issues.filter((issue) => issue.regionKey === selectedRegionKey)
    : issues;
  const selectedRegion = selectedRegionKey ? getBodyRegionDefinition(selectedRegionKey) : null;

  return (
    <section className="rounded-3xl border p-6 md:p-8 bg-white" style={{ borderColor: 'var(--melio-border)' }}>
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] mb-2" style={{ color: 'var(--melio-sage)' }}>
            Issues
          </p>
          <h2 className="text-2xl font-normal" style={{ fontFamily: "var(--melio-display)", color: 'var(--melio-charcoal)' }}>
            {selectedRegion ? `${selectedRegion.label} issues` : 'All tracked issues'}
          </h2>
        </div>
      </div>

      {filteredIssues.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--melio-text-muted)' }}>
          {selectedRegion
            ? `No issues tracked for ${selectedRegion.label.toLowerCase()} yet.`
            : 'No body issues tracked yet.'}
        </p>
      ) : (
        <div className="space-y-3">
          {filteredIssues.map((issue) => {
            const region = getBodyRegionDefinition(issue.regionKey);
            return (
              <Link
                key={issue.id}
                to={`/body-map/issues/${issue.id}`}
                className="block rounded-2xl border px-4 py-4 transition-opacity hover:opacity-90"
                style={{ borderColor: 'var(--melio-border)', backgroundColor: 'var(--b-bone)' }}
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="font-medium mb-1" style={{ color: 'var(--melio-charcoal)' }}>
                      {issue.title}
                    </div>
                    <div className="text-sm" style={{ color: 'var(--melio-text-muted)' }}>
                      {region?.label || issue.regionKey} • {issue.status}
                    </div>
                  </div>
                  {issue.severityBaseline != null && (
                    <span
                      className="rounded-full px-3 py-1 text-xs"
                      style={{ backgroundColor: 'rgba(199, 123, 99, 0.12)', color: 'var(--melio-charcoal)' }}
                    >
                      Severity {issue.severityBaseline}/10
                    </span>
                  )}
                </div>
                {issue.symptomSummary && (
                  <p className="text-sm mt-3" style={{ color: 'var(--melio-text-muted)' }}>
                    {issue.symptomSummary}
                  </p>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
